/** Cache time consuming tasks. */
export class Cache<T extends Record<string, any>> {
  private _store: Partial<T> = {};

  clear(): void {
    for (const key in this._store) {
      delete this._store[key];
    }
  }

  clearItem(key: keyof(T)): void {
    delete this._store[key];
  }

  getItem<K extends keyof(T)>(key: K, refresh: (key: K) => T[K]): T[K] {
    if (key in this._store) {
      return this._store[key]!;
    }

    return this._store[key] = refresh(key);
  }
}
